// Quick-pick default locations (no search required)
export const QUICK_LOCATIONS = [
  {
    name: "Los Angeles",
    country: "USA",
    lat: 34.0522,
    lng: -118.2437,
    timezone: "America/Los_Angeles",
    displayName: "Los Angeles, USA",
  },
  {
    name: "Singapore",
    country: "Singapore",
    lat: 1.3521,
    lng: 103.8198,
    timezone: "Asia/Singapore",
    displayName: "Singapore",
  },
  {
    name: "Mumbai",
    country: "India",
    lat: 19.076,
    lng: 72.8777,
    timezone: "Asia/Kolkata",
    displayName: "Mumbai, India",
  },
];

export const DEFAULT_LOCATION = QUICK_LOCATIONS[0]; // Los Angeles
